import { PAGE_SIZE } from "./MyListingsContainer.consts";
import type {
  MyListingsLocation,
  NuxExperience,
} from "./MyListingsContainer.types";

/**
 * The 1-based page from `?page`, falling back to the first page for anything
 * missing, non-numeric or out of range low.
 */
export const getCurrentPage = (location?: MyListingsLocation) => {
  const page = parseInt(location?.query?.page ?? "", 10);
  return 0 < page ? page : 1;
};

/** The spaces-v2 query for one page of the host's spaces. */
export const buildSpacesQuery = ({
  page,
  SSOid,
}: {
  page: number;
  SSOid: string;
}) => {
  const offset = (page - 1) * PAGE_SIZE;
  return (
    `owner/${SSOid}?full=true&no_deactivated=true` +
    `&limit=${PAGE_SIZE}&offset=${offset}&include_completion_percentage=true`
  );
};

/**
 * The id of a named NUX experience, but only while it's still ACTIVE —
 * callers treat the id as "this experience is due to be shown".
 */
export const getActiveNuxExperienceId = ({
  experienceName,
  experiences,
}: {
  experienceName: string;
  experiences?: NuxExperience[];
}) => {
  const experience = experiences?.find(
    (candidate) => experienceName === candidate.name,
  );
  return "ACTIVE" === experience?.obj_state ? experience._id : undefined;
};

/** Total pages for a space count, never fewer than one. */
export const getTotalPages = (totalSpaces: number) =>
  Math.max(1, Math.ceil(totalSpaces / PAGE_SIZE));
